// Helpers for gold portfolio assets (asset_type "gold" with a
// gold_holdings array of {label, karat, grams, buy_per_gram, last_rate}).

/** "21.5g 22K + 10g 24K · IBJA rates" one-line summary. */
export function goldSummary(asset) {
  const parts = (asset?.gold_holdings || []).map(
    (h) => `${Number(h.grams).toLocaleString("en-IN", { maximumFractionDigits: 3 })}g ${h.karat}K`
  );
  return parts.length ? `${parts.join(" + ")} · IBJA rates` : "";
}

/**
 * Aggregate % gain vs. buy rates. Only holdings with both a buy_per_gram
 * and a last_rate count; returns null when none qualify.
 */
export function goldGainPercent(asset) {
  let invested = 0;
  let current = 0;
  for (const h of asset?.gold_holdings || []) {
    const buy = Number(h.buy_per_gram);
    const last = Number(h.last_rate);
    if (!(h.grams > 0) || !(buy > 0) || !(last > 0)) continue;
    invested += h.grams * buy;
    current += h.grams * last;
  }
  if (!invested) return null;
  return ((current - invested) / invested) * 100;
}
